<template>
    <div>
        <div>
            <div class="dashboard-card-holder">
                  <div class="row">
                     <div class="col-md-6">
                        <div class="card-body">
                              <h6>Wallet Balance</h6>
                              <h3>{{ !visibility ? formattedBalance(availableBalance) : '************' }} <span @click="visibility = !visibility" style="margin-left: 10px; font-size: 20px;"><i class="fa fa-eye-slash" :class="[visibility ? 'fa-eye' : 'fa-eye-slash']"></i></span></h3>
                              <p class="tooltip-container">Asset Value (Expected Income) 
                                 <span class="info-icon">!</span>
                                 <span class="tooltip-text">Expected earnings are the earning from the potential work done, will be moved to wallet after work is done.</span>
                              </p>
                              <small>{{ formattedBalance(expectedBalance) }}</small>

                              <div class="card-buttons">
                                 <button class="btn primary-btn" @click="generateVoucherLink()">Generate voucher</button>
                                 <!-- <div> -->
                                    <button class="btn secondary-btn" @click="withdraw()">Withdraw</button>
                                    <button class="btn secondary-btn" data-toggle="modal" data-target="#moneyConvertion" @click="convertionType = 'ctp'">Convert</button>
                                 <!-- </div> -->
                              </div>
                        </div>
                     </div>
                     <div class="col-md-6">
                        <div class="card-body" @click="pointsLogRoute()" style="cursor: pointer;">
                              <div class="d-flex justify-content-between">
                                 <h6>Main point</h6>
                                 

                                 <label class="switch" @click.stop="">
                                    <label class="autosave-text" for="autosave">Auto save</label>
                                    
                                    <input type="checkbox" v-model="autosave" @change.stop="saveForTrip()"  true-value="1" false-value="0">
                                    <span class="slider"></span>
                                 </label>

                                 <!-- <div class="custom-control custom-switch">
                                    
                                    <input type="checkbox" class="custom-control-input" id="autosave">
                                    <label class="custom-control-label" for="autosave">Auto save</label>
                                 </div> -->

                                 <!-- <div class="form-check form-switch">
                                    <label class="form-check-label" for="autosave">Auto save</label>
                                    <input type="checkbox" class="form-check-input" id="autosave">
                                 </div> -->
                              </div>
                              <h3>{{ toTwoDecimal(readyPoints) }} Points</h3>
                              <div class="d-flex justify-content-between">
                                 <div>
                                    <p class="tooltip-container">Promo points
                                       <span class="info-icon">!</span>
                                       <span class="tooltip-text">This are points earned during promo and is added to your main points after promo is over.</span>
                                    </p>
                                    <small>{{ promopointmain }} points</small>
                                 </div>
                                 <div>
                                    <p class="tooltip-container">Bonus points
                                       <span class="info-icon">!</span>
                                       <span class="tooltip-text">These are bonus points earned when you participate in one activity or the other.</span>
                                    </p>
                                    <small>{{ bonusBalance }} points</small>
                                 </div>
                              </div>

                              <div class="card-buttons">
                                 <button class="btn secondary-btn" @click.stop="openModalForPoint(); convertionType = 'ptc'">Convert</button>
                                 <!-- <button class="btn secondary-btn" @click="pointsLogRoute()">Points log</button> -->
                                 <!-- <div> -->
                                    <button class="btn secondary-btn" disabled>Transfer</button>
                                    <button :disabled="userData.lock_smart_wallet == 1" class="btn secondary-btn" @click.stop="moveToSmartLock()">Lock</button>
                                   
                                 <!-- </div> -->
                              </div>
                        </div>
                     </div>
                  </div>
            </div>
            <div class="modal fade" tabindex="-1" id="moneyConvertion">
               <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                  <div class="modal-content">
                        <div class="modal-header">
                           <h5 class="modal-title">Convert Cash to point</h5>
                           <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                           <span aria-hidden="true">&times;</span>
                           </button>
                        </div>
                        <div class="transfer-content modal-body">
                           
                           <div class="form-group nairaSign">
                              <p class="currency-symbol">₦</p>
                              <input v-model="formattedAmount" @input="formatAmountCommas" class="form-control point-input" type="text" name="amounttoconvert" id="amounttoconvert" placeholder="0">
                           </div>
 
                           <div class="form-group convert-point-btn">
                              <button :disabled="converting" class="btn cancel" data-dismiss="modal" aria-label="Close">Cancel</button>
                              <!-- <button @click="convertCashToPoint()" :disabled="converting" class="convert btn">
                                    {{ converting ? 'Converting...' : 'Convert' }}
                              </button> -->
                              <button @click="openConfirmPin2()" class="convert btn">
                                 Continue
                              </button>
                           </div>
                        </div>
                  </div>
               </div> 
            </div>

            <!-- Point to cash convertion starts here -->
            <div class="modal fade" tabindex="-1" id="pointConvertion">
               <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                  <div class="modal-content">
                        <div class="modal-header">
                           <h5 class="modal-title">Convert point to cash</h5>
                           <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                           <span aria-hidden="true">&times;</span>
                           </button>
                        </div>
                        <div class="transfer-content modal-body">
                           
                           <!-- <div class="form-group">
                              <input v-model="formattedAmount" @input="formatAmountCommas" class="form-control" type="text" name="amounttoconvert" id="amounttoconvert" placeholder="Amount to convert">
                           </div> -->

                           <div class="mb-4">
                              <p class="points-to-convert">Point balance: <span>{{ toTwoDecimal(readyPoints) }}</span></p>
                              <!-- <p class="points-to-convert">Point balance: <span>{{ Math.floor(readyPoints) || 0 }}</span></p> -->

                           </div>


                           <div class="form-group">
                              <input style="text-align: center !important; padding-left: 12px" v-model="selectedpoints" class="form-control point-input" type="number" name="points" id="points">
                           </div>

                           <p class="min-point">Minimum point to convert: 1</p>
                           <hr>


                           <div class="amount-breakdown" v-if="selectedpoints != 0">
                              <div class="d-flex justify-content-between mb-2">
                                 <h6>Total cash value</h6>
                                 <h6>{{ (selectedpoints * 1000).toLocaleString() }}</h6>
                              </div>
                              <div class="d-flex justify-content-between mb-2">
                                 <h6>Conversion charge</h6>
                                 <h6>5%</h6>
                              </div>
                              <div class="d-flex justify-content-between mb-2">
                                 <h6>Amount Receivable</h6>
                                 <h6>{{ (amountDeduction).toLocaleString() }}</h6>
                              </div>
                           </div>

                           <hr v-if="selectedpoints != 0">
 
                           <div class="form-group convert-point-btn">
                              <button :disabled="converting" class="btn cancel" data-dismiss="modal" aria-label="Close">Cancel</button>
                              <!-- <button @click="convertCashToPoint()" :disabled="converting" class="convert btn">
                                    {{ converting ? 'Converting...' : 'Convert' }}

                              </button> -->
                              <button @click="openConfirmPin()" :disabled="verifing" class="convert btn">
                                    <!-- {{ converting ? 'Converting...' : 'Continue' }} -->
                                    Continue
                              </button>
                           </div>
                        </div>
                  </div>
               </div> 
            </div>
            <!-- Point to cash convertion ends here -->
            <TransactionPinVerification @send-data="handleDataFromTransactionPinModal" />

        </div>
    </div>
</template>


<script>
import $ from "jquery";
import currencyFormatter from "../helpers/currencyFormatter";
import CF from "../helpers/currencyFormatter";
import points from "../services/points";
import trip from "../services/trip";
import TransactionPinVerification from "./TransactionPinVerification.vue";
import userCredentials from "../services/userCredentials";
export default {
    name: "DashboardCard",
    components: {
    // Loader,
    TransactionPinVerification,
   },
    data() {
        return {
            loading: false,
            visibility: true,
            loadingAutosave: false,
            autosave: '',
            converting: false,
            verifing: false,
            availableBalance: 0,
            expectedBalance: 0,
            promopointmain: 0,
            bonusBalance: 0,

            selectedpoints: 0,
            amountDeduction: 0,
            percentageAmount: 0,
            readyPoints: null,
            expectedPoints: null,
            transactionCount: null,
            formattedAmount: "",
            userData: "",
        }
    },
    watch: {
      selectedpoints(newValue) {
         if (newValue) {
             this.getFivePercent();
         }
     },
     deep: true,
    },
    mounted() {
        this.startAutoSlide();
        let user = this.$store.getters.getUser;
        this.userData = this.$store.getters.getUser;

        this.autosave = localStorage.getItem("autosave");
        if (user.auto_save_smart_point == 1) {
            localStorage.setItem("autosave", '1');
        }

        this.startAutoSlide();
        this.getDashboardSummary();
        // this.fetchFacilityDashboardSummary();
    },
    methods: {
        getFivePercent() {
            this.percentageAmount = ((this.selectedpoints * 1000) * 0.05);
            return this.amountDeduction = ((this.selectedpoints * 1000) - this.percentageAmount);
        },
        openModalForCashconvertion() {
            $("#moneyConvertion")
            .addClass("fade")
            .modal("show");
        },
        openModalForPoint() {
            $("#pointConvertion")
            .addClass("fade")
            .modal("show");
        }, 
        generateVoucherLink() {
         // console.og("clikced to generate", this.userData)
            if(this.userData.subscribed == 'YES') {
               this.$router.push({path: `/user/voucher`});
            }
            else {
               return this.$toast.error("You are not subscribed");
            }
            
        },
        withdraw() {
            this.$router.push({path: `/user/dashboard/wallet`});
        },
        moveToSmartLock() {
            this.$router.push({path: `/user/smart-lock`});
        },
        pointsLogRoute() {
            this.$router.push({path: `/user/dashboard/point-logs`});
        },
        
        openConfirmPin() {
         if (this.selectedpoints < 1) { 
            return this.$toast.error("Point can not be less than 1");
         }
         if (this.selectedpoints == '0') {
            return this.$toast.error("Point can not be 0");
         }
         if (this.selectedpoints == '' || this.selectedpoints == null) {
            return this.$toast.error("Point can not be empty");
         }
         $("#pointConvertion")
        .removeClass("fade")
        .modal("hide");
         return this.$root.$refs.pin.openPinModal();
        }, 
        openConfirmPin2() {
            if (this.cashAmount == '0') {
                this.converting = false;
                return this.$toast.error("Amount can not be 0");
            }
            if (this.cashAmount == '') {
                this.converting = false;
                return this.$toast.error("Enter amount to convert");
            }
            if (this.availableBalance < this.cashAmount) {
                this.converting = false;
                return this.$toast.error("Wallet balance too low");
            }
            $("#moneyConvertion")
            .removeClass("fade")
            .modal("hide");
            return this.$root.$refs.pin.openPinModal();
        },
        removeLeadingZero(str) {
            return str.replace(/^0+/, '');
        },
        handleDataFromTransactionPinModal(data) {
            this.receivedDataFromPinModal = data;
            if (this.convertionType == 'ptc') {
            return this.convertPointToCash();
            }
            if (this.convertionType == 'ctp') {
            return this.convertCashToPoint();
            }
        
        },
        async convertPointToCash() {
            const point = this.removeLeadingZero(this.selectedpoints);
            $("#pointConvertion")
                .addClass("fade")
                .modal("show");
            let body = {
                points: point,
            };

            body = JSON.stringify(body);
            try {
                await points.convertPointDirect(body).then(data => {
                // console.log("Point Convertion", data);
                this.selectedpoints = 0;
                if (data.success) {
                    this.$toast.success("Points convertion done");
                    this.selectedpoints = 0;
                    this.$emit('callDasboardSummary');
                    this.getDashboardSummary();
                  //   this.dashboardSummary();
                    $("#pointConvertion")
                    .removeClass("fade")
                    .modal("hide");
                }
                if (data.error) {
                    this.$toast.error(data.error);
                    this.selectedpoints = 0;
                    return this.$root.$refs.pin.closePinModal();
                }
                }) .catch((err) => {
                // this.$toast.error("please check your network and refresh the page");
                $("#pointConvertion")
                .removeClass("fade")
                .modal("hide");
                this.selectedpoints = 0;
                console.log(err);
                })
            } finally {
                // console.log("Finally")
            }
        },
        async fetchPromoPoint() {
            try {
                await points
                .promoPoint()
                .then(data => {
                if (data.success) {
                    // console.log("points", data)
                    this.promopointmain = data.save_for_trip_balacne;
                    this.$store.dispatch("saveUser", data.user);
                } else {
                    this.$toast.error(data.error);
                }
                })
                .catch((err) => {
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
                });
            } finally {
                // console.log("closed")
            }
        },
        async convertCashToPoint() {
            $("#moneyConvertion")
            .addClass("fade")
            .modal("show");
            this.converting = true;
            if (this.cashAmount == '') {
                this.converting = false;
                return this.$toast.error("Enter amount to convert");
            }
            if (this.availableBalance < this.cashAmount) {
                this.converting = false;
                return this.$toast.error("Wallet balance too low");
            }
            let body = {
                amount: this.cashAmount,
            }
            try {
                await points.convertCashToPointDirect(JSON.stringify(body)).then((res) => {
                this.converting = false;
                if (res.success) {
                    this.$toast.success("Cash converted to point successfully");
                    this.getDashboardSummary();
                    $("#moneyConvertion")
                    .removeClass("fade")
                    .modal("hide");
                }
                if (res.error) {
                    this.$toast.error(res.error);
                }
                }).catch((err) => {
                this.converting = false;
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
                });
            } finally {
                // console.log("closed");
            }
            
        },
        
        formatAmountCommas() {
            let value = this.formattedAmount.replace(/,/g, ""); // Remove existing commas
            if (!isNaN(value) && value !== "") {
            this.cashAmount = value; // Store unformatted value
            this.formattedAmount = Number(value).toLocaleString(); // Add commas
            } else {
            this.formattedAmount = "";
            this.cashAmount = "";
            }
        },
        async saveForTrip() {
            this.loadingAutosave = true;
            if (this.autosave == '1') {
            // console.log("auto save", this.autosave)
            await trip.autoSave({}).then(data => {
               this.loadingAutosave = false;
               if (data.success) {
                  this.$toast.success("SUCCESS, AUTO SAVE ACTIVATED SUCCESSFULY");
                  localStorage.setItem("autosave", '1');
                  this.autosave = localStorage.getItem("autosave");
                  // this.autosave = 0;
                  // this.autosave++;
                  // return window.location.reload(true);
               }
               if (data.error) {
                  return this.$toast.error(data.error);
               }   
               
            }).catch((err) => {
               console.log(err);
               this.loadingAutosave = false;
                  // this.$toast.error("please check your network and refresh the page");
            });
            }

            if (this.autosave == '0') {
            // console.log("auto save", this.autosave)
            await trip.autoSaveDeactivated({}).then(data => {
               this.loadingAutosave = false;
               if (data.success) {
                  this.$toast.success("SUCCESS, AUTO SAVE DEACTIVATED SUCCESSFULY");
                  localStorage.setItem("autosave", '0');
                  this.autosave = localStorage.getItem("autosave");
                  // this.autosave = 1;
                  // this.autosave++;
                  // this.autosave = (this.userData.auto_save_smart_point).toString();
                  // return window.location.reload(true);
               }
               if (data.error) {
                  return this.$toast.error(data.error);
               }   
               
            }).catch((err) => {
                  this.loadingAutosave = false;
                  console.log(err);
                  // this.$toast.error("please check your network and refresh the page");
            });
            }
        
        },
        startAutoSlide() {
            this.interval = setInterval(this.nextSlide, 4000);
        },
        stopAutoSlide() {
            clearInterval(this.interval);
        },
        formattedBalance(amount) {
            return CF.naira.format(amount);
        },
        toTwoDecimal(value) {
            return CF.toTwoDecimal(value);
        },
        formatAmount(value) {
            return currencyFormatter.toTwoDecimal(value);
        },
        async getDashboardSummary() {
            if(this.userData.id != "" || this.userData.id == null) {
                try {
                await userCredentials
                .dashboardSummary(this.userData.id)
                .then(data => {
                    // console.log("adata", data)
                if (data.success) {
                    this.availableBalance = data.readywallet;
                    this.expectedBalance = data.expectedwallet;
                    this.transactionCount = data.transactions;
                    this.readyPoints = data.readypoint;
                    this.expectedPoints = data.expectedpoint;
                } else {
                    this.$toast.error(data.error);
                }
                })
            .catch((err) => {
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
            });
                } finally {
                // console.log("closed")
                }
            }
        }
        // async fetchFacilityDashboardSummary() {
        //     this.loading = true;
        //     if(this.userID != "" || this.userID != null) {
        //         this.loading = true;
        //         try {
        //             await partners.facilityDasboard(this.userID).then((res) => {
        //             console.log("Response", res);
        //             this.loading = false;
        //             if(res.success) {
        //                 this.dashboardData = res;
        //                 this.pendingTask = res.pending_task;
        //                 this.performersData = res.performance;
        //                 this.ongoingMaintainance = res.ongoing_maintainace;
        //                 this.ongoingInspection = res.ongoing_inspection;
        //                 const valuesArray = Object.values(this.performersData);
        //                 this.series = valuesArray; // Update the chart dynamically

        //                 this.recentActivities = res.recent_activities;
        //                 this.propertySingleRequest = res.single_property_request;
        //                 this.fmioRequest = res.single_fm_request;
        //                 this.maintainanceRequest = res.single_maintenace_request;
        //                 this.requestData['propertyAssign'] = res.single_property_request;
        //                 this.requestData['fmio'] = res.single_fm_request;
        //                 this.requestData['maintainance'] = res.single_maintenace_request;
        //                 this.startCountdownTop();
        //                 this.startCountdownTop2();
        //                 this.startCountdownTop3();
        //                 // this.openPopUp();
        //             }
        //             }).catch((err) => {
        //                 console.log(err);
        //                 this.loading = false;
        //             });
        //         } finally {
        //             // console.log("stoped");
        //         }
        //     }
        // },
        
    },
}

</script>



<style lang="scss" scoped>

.card-body {
   border: 1px solid #E9EAEB;
   padding: 20px;
   border-radius: 10px;
   margin-top: 20px;
   background: #ffffff;
   h6 {
      font-family: Lato;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0%;

   }
   h3 {
      font-family: Lato;
      font-weight: 600;
      font-size: 30px;
      line-height: 38px;
      color: #2B3352;
   }
   p {
      font-family: Lato;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #555C74;
      position: relative;
      width: fit-content;

   }
   small {
      font-family: Lato;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #2B3352;
   }
}

.card-buttons {
   margin-top: 20px;
   button {
      margin-right: 10px;
      margin-bottom: 15px;
      outline: 0;
      box-shadow: none;
   }
}
.primary-btn {
   font-family: Lato;
   font-weight: 400;
   font-size: 14px;
   background: #0033EA;
   color: #ffffff;
   
}

.secondary-btn {
   font-family: Lato;
   font-weight: 400;
   font-size: 14px;
   border: 1px solid #D5D7DA;
   color: #414651;
}


.tooltip-text {
   visibility: hidden;
   width: 200px;
   background-color: #333;
   color: #fff;
   text-align: center;
   border-radius: 5px;
   padding: 5px 10px;
   position: absolute;
   z-index: 10;
   bottom: 125%; /* Position the tooltip above the element */
   left: 83px;
   transform: translateX(-50%);
   opacity: 0;
   transition: opacity 0.3s;
   text-align: left;
   // white-space: nowrap;
}

 /* Tooltip arrow */
 .tooltip-text::after {
   content: '';
   position: absolute;
   top: 100%;
   left: 50%;
   transform: translateX(-50%);
   border-width: 5px;
   border-style: solid;
   border-color: #333 transparent transparent transparent;
}

.info-icon {
   border: 1px solid #555C74;
   padding: 0px 6px;
   border-radius: 50px;
   margin-left: 2px;
   color: #555C74;
}


.tooltip-container {
   position: relative;
   // display: inline-block;
   cursor: pointer;
}


/* Show tooltip on hover */
.tooltip-container:hover .tooltip-text {
   visibility: visible;
   opacity: 1;
}



 /* Toggle Switch */
.switch {
   position: relative;
   display: inline-block;
   width: 50px;
   height: 24px;
   cursor: pointer;
}

.switch input {
   opacity: 0;
   width: 0;
   height: 0;
}

.slider {
   position: absolute;
   cursor: pointer;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   background-color: #ccc;
   transition: 0.4s;
   border-radius: 24px;
}

.slider:before {
   position: absolute;
   content: "";
   height: 18px;
   width: 18px;
   left: 3px;
   bottom: 3px;
   background-color: white;
   transition: 0.4s;
   border-radius: 50%;
}

input:checked + .slider {
   background-color: #4CAF50;
}

input:checked + .slider:before {
   transform: translateX(26px);
}

.autosave-text {
   position: absolute;
   left: -63px;
   top: 0px;
   font-family: Lato;
   font-weight: 400;
   font-size: 14px;
   color: #555C74;
   // line-height: 20px;

}




.convert-point-btn {
   display: flex;
   justify-content: right;
   button {
      outline: 0;
      box-shadow: none;
      font-family: Lato;
      font-weight: 400;
      font-size: 14px;
   }
   .cancel {
      border: 1px solid #D5D7DA;
      color: #414651;
      background: white;
      margin-right: 10px;
   }
   .convert {
      background: #0033ea;
      color: #ffffff;
   }
}

input {
   height: 48px;
   box-shadow: none !important;
   outline: 0 !important;

}

.point-input {
   border: none;
   font-family: Lato;
   font-weight: 400;
   font-size: 72px;
   line-height: 90px;
   text-align: left;
   padding-left: 70px;
   height: 80px;
}

.points-to-convert {
   border: 1px solid #E9EAEB;
   background: #FAFAFA;
   font-family: Lato;
   font-weight: 500;
   font-size: 14px;
   line-height: 20px;
   border-radius: 8px;
   padding: 4px 10px;
   text-align: center;
   width: fit-content;
   margin: auto !important;
   color: #555C74;
   span {
      color: #555C74;
      font-weight: bold;
   }

}
.amount-breakdown {
  h6 {
    font-size: 16px;
    font-weight: 400;
  }
}
.min-point {
   font-family: Lato;
   font-weight: 500;
   font-size: 14px;
   line-height: 20px;
   color: #555C74;
   text-align: center;
   margin-bottom: 40px !important;
}

.nairaSign {
   position: relative;
   display: flex;
   align-items: center;
   color: #495057;
   // width: 150px;
}

.currency-symbol {
  position: absolute;
  left: 10px;
  font-size: 72px;
  color: #333;
  font-weight: bold;
  padding-top: 10px;
}

@media screen and (max-width: 599px) { 
   .card-buttons {
      button {
         width: 100%;
         margin-bottom: 5px;
      }
   }
   .tlh {
    gap: 10px;
      div {
         h6 {
               width: 100px;
         }
      }
   }
   .opportuity-desk-text {
      margin-top: 30px;
   }
   .point-input {
      font-size: 35px;
      padding-left: 44px;
   }
   .currency-symbol {
      font-size: 35px;
      padding-top: 4px;
   }
}


</style>